// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/CRIBVEST Landscape Logo - White.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NavBarDashboard_navBarCon__PebjX {
	background-color: #052E26;
	top: 0;
	left: 0;
}

.NavBarDashboard_navBar__5yLsC {
	/* padding: 0 90px; */
	height: 136px;
	background-color: #052E26;
	max-width: 1240px !important;
}

.NavBarDashboard_innerMain__XTCRI {
	max-width: 1240px !important;
}

.NavBarDashboard_logoContainer__EegfI {
	/* margin-top: 44px; */
	width: 150px;
	height: 20px;
	flex-shrink: 0;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
}

.NavBarDashboard_navItem__RYWz4 {
	display: inline-flex;
	height: 45px;
	padding: 0px 18px;
	justify-content: center;
	align-items: center;
	gap: 7px;
	flex-shrink: 0;
	border-radius: 25px;
	color: #fff !important;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 133.333% */
}

.NavBarDashboard_focused__4vZ45 {
	background: #f2be15 !important;
	color: #000 !important;
}

.NavBarDashboard_icon__1dQc8 {
	/* color: #fff !important; */
	/* fill: #fff !important; */
	width: 16px;
	height: 16px;
}

.NavBarDashboard_iconFocused__e74JP {
	color: #000 !important;
	fill: #000 !important;
}

.NavBarDashboard_hamburger__iYRWU {
	display: flex;
	width: 36px;
	height: 36px;
	padding: 9px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
}

.NavBarDashboard_isSmall__-rIl2 {
	display: none !important;
}

.NavBarDashboard_tinyNavBarPurple__ltHWp {
	height: calc(100vh - 136px);
	padding-top: 0;
	padding-bottom: 25px;
	background: #052E26;
}

.NavBarDashboard_tinyNavItemPurple__WcZF6 {
	color: #fff;
	border-bottom: 1px solid #94709b;
}

.NavBarDashboard_tinyLogoutConPurple__METag .NavBarDashboard_tinyNavItemPurple__WcZF6 {
	border-top: 1px solid #94709b;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
}

@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) {
}

@media only screen and (max-width: 820px) and (min-height: 441px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {
}

@media only screen and (max-width: 480px) {
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-width: 360px) and (min-width: 301px) {
}

@media only screen and (max-width: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/NavBarDashboard.module.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;CACzB,MAAM;CACN,OAAO;AACR;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,YAAY;CACZ,cAAc;CACd,mDAAuE;CACvE,2BAA2B;CAC3B,wBAAwB;CACxB,4BAA4B;AAC7B;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,mBAAmB;CACnB,sBAAsB;CACtB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,8BAA8B;CAC9B,sBAAsB;AACvB;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,WAAW;CACX,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,2BAA2B;CAC3B,cAAc;CACd,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gCAAgC;AACjC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA,yDAAyD;AACzD;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".navBarCon {\n\tbackground-color: #052E26;\n\ttop: 0;\n\tleft: 0;\n}\n\n.navBar {\n\t/* padding: 0 90px; */\n\theight: 136px;\n\tbackground-color: #052E26;\n\tmax-width: 1240px !important;\n}\n\n.innerMain {\n\tmax-width: 1240px !important;\n}\n\n.logoContainer {\n\t/* margin-top: 44px; */\n\twidth: 150px;\n\theight: 20px;\n\tflex-shrink: 0;\n\tbackground: url('../assets/images/CRIBVEST Landscape Logo - White.png');\n\tbackground-position: center;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n}\n\n.navItem {\n\tdisplay: inline-flex;\n\theight: 45px;\n\tpadding: 0px 18px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 7px;\n\tflex-shrink: 0;\n\tborder-radius: 25px;\n\tcolor: #fff !important;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 133.333% */\n}\n\n.focused {\n\tbackground: #f2be15 !important;\n\tcolor: #000 !important;\n}\n\n.icon {\n\t/* color: #fff !important; */\n\t/* fill: #fff !important; */\n\twidth: 16px;\n\theight: 16px;\n}\n\n.iconFocused {\n\tcolor: #000 !important;\n\tfill: #000 !important;\n}\n\n.hamburger {\n\tdisplay: flex;\n\twidth: 36px;\n\theight: 36px;\n\tpadding: 9px;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-shrink: 0;\n}\n\n.isSmall {\n\tdisplay: none !important;\n}\n\n.tinyNavBarPurple {\n\theight: calc(100vh - 136px);\n\tpadding-top: 0;\n\tpadding-bottom: 25px;\n\tbackground: #052E26;\n}\n\n.tinyNavItemPurple {\n\tcolor: #fff;\n\tborder-bottom: 1px solid #94709b;\n}\n\n.tinyLogoutConPurple .tinyNavItemPurple {\n\tborder-top: 1px solid #94709b;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n}\n\n@media only screen and (max-width: 900px) and (min-width: 821px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) {\n}\n\n@media only screen and (max-width: 820px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) and (min-height: 441px) {\n}\n\n@media only screen and (max-width: 480px) {\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-width: 360px) and (min-width: 301px) {\n}\n\n@media only screen and (max-width: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navBarCon": `NavBarDashboard_navBarCon__PebjX`,
	"navBar": `NavBarDashboard_navBar__5yLsC`,
	"innerMain": `NavBarDashboard_innerMain__XTCRI`,
	"logoContainer": `NavBarDashboard_logoContainer__EegfI`,
	"navItem": `NavBarDashboard_navItem__RYWz4`,
	"focused": `NavBarDashboard_focused__4vZ45`,
	"icon": `NavBarDashboard_icon__1dQc8`,
	"iconFocused": `NavBarDashboard_iconFocused__e74JP`,
	"hamburger": `NavBarDashboard_hamburger__iYRWU`,
	"isSmall": `NavBarDashboard_isSmall__-rIl2`,
	"tinyNavBarPurple": `NavBarDashboard_tinyNavBarPurple__ltHWp`,
	"tinyNavItemPurple": `NavBarDashboard_tinyNavItemPurple__WcZF6`,
	"tinyLogoutConPurple": `NavBarDashboard_tinyLogoutConPurple__METag`
};
export default ___CSS_LOADER_EXPORT___;
